export default __webpack_public_path__ + "static/media/group-option-birthday-selected.7bcc8c3c.svg";